<template>
  <v-navigation-drawer
    app
    clipped
    v-model="DRAWER_STATE"
    :mini-variant="!DRAWER_STATE"
    :width="sidebarWidth"
    :permanent="$vuetify.breakpoint.lgAndUp"
    :temporary="$vuetify.breakpoint.mdAndDown"
    :mini-variant-width="sidebarMinWidth"
    :class="{'drawer-mini': !DRAWER_STATE}"
    v-if="languageData.header">
    <v-list>
      <template v-for="(item, i) in sidebarHeaders">
        <v-row
          v-if="item.heading"
          :key="item.heading"
          >
          <v-col cols="6">
            <span
              style="padding-left: 32px;"
              class="text-body-1 subheader"
              :class="(item.heading && DRAWER_STATE) ? 'show ' : 'hide'">
              {{ item.heading }}
            </span>
          </v-col>
          <v-col
              cols="6"
              class="text-center">
          </v-col>
        </v-row>
        <v-divider
            v-else-if="item.divider"
            :key="i"
            dark
            class="my-4"
        ></v-divider>
        <v-list-group
          color="primary"
          v-else-if="item.children && DRAWER_STATE"
          :key="item.title"
          v-model="item.model"
          >
          <template v-slot:prependIcon>
            <v-icon size="24" class="mr-0" color="fontDefault"> {{ item.icon }} </v-icon>
          </template>
          <template v-slot:activator >
            <v-list-item-content>
              <v-badge v-if="item.badge" content="New" color="primary">
              </v-badge>
              <v-list-item-title class="text-left ml-3 d-flex">
                {{ item.title }}
               <span v-on:click.stop @click="openGuidesModal(item.guide_key)" class="guides-question-mark" v-if="item.guides">{{item.guides}}</span>
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.link"
              link
              exact
              class="pl-12"
              :class="{ 'v-list-item--active': isRouteModule(child) }"
              @click="child.action ? child.action() : null"
          >
            <v-list-item-action class="mr-2" v-if="child.icon">
              <v-icon size="">{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="d-flex justify-center">
                {{ child.title }}
                <span v-on:click.prevent.stop @click="openGuidesModal(child.guide_key)" class="guides-question-mark" style="padding-left: 0 !important" v-if="child.guides">{{child.guides}}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
            color="primary"
            class="text-left"
            v-else
            :key="item.text"
            :to="item.link === '#' ? '' : item.link"
            @click="item.action ? item.action() : null"
            link
        >
          <v-list-item-action class="mr-6">
            <v-icon
                :size="item.size ? item.size : 24"
                :color="item.color ? item.color : 'fontDefault'"
            >{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
                link
                class="ml-3"
            >
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <ModalInfo v-if="isShowCreateInvoiceModal && $route.name !== 'ProjectsEdit'" :layout="'modalCreateInvoice'" :hidden-agree-btn="true" @clicked="hideModalCreateInvoice" :show-modal="isShowCreateInvoiceModal">
      <template v-slot:body>
        <Invoice modelType="invoice" :projectData="null"></Invoice>
      </template>
    </ModalInfo>
     <ModalInfo :layout="'guidesModal'" :hidden-agree-btn="true" @clicked="hideGuidesModal" :show-modal="isGuidesModalVisible">
      <template v-slot:body>
        <Guides v-if="guideKey" :guideKey="guideKey"></Guides>
      </template>
    </ModalInfo>
    <ModalInfo
        v-if="isInvoiceSave"
        :typeInfo="typeInfoInvoiceSave"
        :headModal="headInfoInvoiceSave"
        :btnAgreeText="languageData.btnAgreeText"
        :visDisAgreeBtn="false"
        @clicked="hideInvoiceModal"
        :show-modal="isInvoiceSave"
        :text-modal="textInfoInvoiceSave">
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideModalSendTimeReport"  :show-modal="isModalSendTimeReportVisible">
      <template v-slot:header>
        <v-row justify="center" class="mb-4">
          {{ languageData.labels.sendTimeReport}}
        </v-row>
      </template>
      <template v-slot:body>
        <v-row justify="center">
           <v-btn
              color="primary"
              class="button-shadow mr-3"
              @click="showTimeReportPersons">
              {{ languageData.choosePersonAndSend }}
           </v-btn>
           <v-btn
              color="primary"
              class="button-shadow"
              @click="showTimeReportEmailForm">
              {{ languageData.typeEmailAndSend }}
           </v-btn>
        </v-row>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="updateVisibleTimeReportClientPersonsModal" :show-modal="isShowTimeReportClientPersonsModal">
      <template v-slot:header>
        {{ languageData.labels.sendTimeReport }}
      </template>
      <template v-slot:body>
        <template>
          <ClientPersonsList :clientPersons="clientPersons" layout="timeReport"></ClientPersonsList>
        </template>
        <template>
          <p class="favorite-contacts-header">{{ languageData.favoriteContacts}}</p>
          <FavoriteContactsTable layout="sendEmail" emailType="timeReport"></FavoriteContactsTable>
        </template>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalForm'" @clicked="updateVisibleTimeReportSendEmailModal" :show-modal="isShowTimeReportSendEmailModal">
      <template v-slot:header>
        {{ languageData.labels.sendTimeReport }}
      </template>
      <template v-slot:body>
        <SendEmailForm></SendEmailForm>
      </template>
    </ModalInfo>
    <ModalInfo v-if="isShowTimeReportSummaryTableModal" :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideTimeReportSummaryTableModal" :show-modal="isShowTimeReportSummaryTableModal">
      <template v-slot:body>
        <TimeReportSummaryItemsTable :timeReport="timeReport"></TimeReportSummaryItemsTable>
      </template>
    </ModalInfo>
    <ModalInfo
      v-if="languageData.confirmTimeReportSummaryResponseModal && confirmTimeReportSummaryResponseModalData.isShow"
      @doOperation="hideConfirmTimeReportSummaryResponseModal"
      :isLoadingBtn="false"
      :typeInfo="'info'"
      :headModal="confirmTimeReportSummaryResponseModalData.head"
      :btnAgreeText="languageData.confirmTimeReportSummaryResponseModal.btnAgreeText"
      :visDisAgreeBtn="false" 
      @clicked="hideConfirmTimeReportSummaryResponseModal"
      :show-modal="confirmTimeReportSummaryResponseModalData.isShow"
      :text-modal="confirmTimeReportSummaryResponseModalData.textInfo">
  </ModalInfo>
  </v-navigation-drawer>
</template>

<script type="text/javascript">
import {mapActions, mapState} from "vuex";
import eventBus from "../../event-bus/eventBus";
import ModalInfo from "../ModalInfo/ModalInfo";
import Invoice from "../../modules/Invoices/components/Invoice/Invoice";
import downloadFileHelper from "../../helpers/downloadFileHelper";
import Guides from "../../modules/Guides/components/Guides.vue";
import ClientPersonsList from "../../modules/Clients/components/ClientPersonsList/ClientPersonsList.vue";
import FavoriteContactsTable from "../../modules/Company/components/FavoriteContacts/FavoriteContactsTable.vue";
import SendEmailForm from "../../modules/TimeReports/components/SendEmailForm/SendEmailForm.vue";
import TimeReportSummaryItemsTable from "../../modules/TimeReports/components/TimeReportSummary/TimeReportSummaryItemsTable.vue";

export default {
  name: "SidebarCompany",
  components: {ModalInfo, Invoice, Guides, ClientPersonsList, FavoriteContactsTable, SendEmailForm, TimeReportSummaryItemsTable},
  props: {
    source: String,
  },
  data(){
    return {
      sidebarWidth: 280,
      sidebarMinWidth: 96,
      chat: false,
      chatMessage: '',
      path: "",
      isShowGuidesModal: false
    }
  },
  mounted() {
    const language = this.getCurrentLanguage;
    const pathParams = window.location.pathname.split("/");
    this.path = pathParams[1];
    const path = this.path;
    this.getSidebarHeaders({creds: { language, path }});
    this.getProjects();

    eventBus.$on("changeLanguage", (data) => {
      const language = data;
      this.getSidebarHeaders({ creds: { language, path } });
    });
    eventBus.$on("getSidebarHeaders", () => {
      this.getSidebarHeaders({ creds: { language, path } });
    });
    eventBus.$on("saveInvoiceSuccess", () => {
      this.updateVisibleCreateInvoiceModal(false);   
    });
    eventBus.$on('confirmInvoiceSuccess', (data) => {
      this.downloadInvoicePdf(data);
    });
    eventBus.$on("saveTimeReportPDFSuccess", (data) => {
      this.downloadTimeReportPdf(data);
    });
    eventBus.$on("sendInvoiceSuccess", () => {
      this.updateVisibleCreateInvoiceModal(false);
    });
    eventBus.$on("successGetSidebarHeaders", () => {
      Object.entries(this.sidebarHeaders).forEach(header => {
        if(Object.prototype.hasOwnProperty.call(header[1], 'children')) {
          header[1].children.forEach(element => {
            if(Object.prototype.hasOwnProperty.call(element, 'action')) {
              element.action = this[element.action];
            }
          });
        }
      });
    });
    eventBus.$on('confirmTimeReportSummarySuccess', () => {
      this.updateVisibleTimeReportSummaryTableModal({
        isModalVisible: false,
        timeReportItems: [],
        timeReportId: null
      })
    });
    eventBus.$on('sendTimeReportSuccess', () => {
      this.updateVisibleTimeReportClientPersonsModal(false);
    })
    eventBus.$on('sendTimeReportSuccess', () => {
      this.updateVisibleTimeReportSendEmailModal(false);
    })
  },
  computed: {
    ...mapState( 'layoutCompany', {
      drawer: state => state.drawer,
      sidebarHeaders: state => state.sidebarHeaders
    } ),
    ...mapState("updateVisibleCreateInvoiceModal", {
      isShowCreateInvoiceModal: state => state.isShowCreateInvoiceModal
    }),
    ...mapState("getProjects", {
      projects: state => state.dataReceive
    }),
    ...mapState("getInvoice", {
      invoice: state => state.dataReceive,
    }),
    ...mapState("updateVisibleGuideModal", {
      isGuidesModalVisible: state => state.isGuidesModalVisible,
      guideKey: state => state.guideKey,
    }),
     ...mapState("saveInvoice", {
      textInfoInvoiceSave: state => state.textInfoInvoiceSave,
      typeInfoInvoiceSave: state => state.typeInfoInvoiceSave,
      headInfoInvoiceSave: state => state.headInfoInvoiceSave,
      isInvoiceSave: state => state.isInvoiceSave,
    }),
    ...mapState("saveProjectReport", {
      isModalSendTimeReportVisible: state => state.isModalSendTimeReportVisible,
      timeReportData: state => state.timeReport,
    }),
     ...mapState("updateVisibleTimeReportClientPersonsModal", {
      isShowTimeReportClientPersonsModal: state => state.isShowTimeReportClientPersonsModal
    }),
    ...mapState("getTimeReportClientPersons", {
      clientPersons: state => state.clientPersons
    }),
    ...mapState("updateVisibleTimeReportSendEmailModal", {
      isShowTimeReportSendEmailModal: state => state.isShowTimeReportSendEmailModal
    }),
    ...mapState("updateVisibleTimeReportSummaryTableModal", {
      isShowTimeReportSummaryTableModal: state => state.isShowTimeReportSummaryTableModal,
      timeReport: state => state.timeReport,
    }),
    ...mapState("confirmTimeReportSummary", {
      confirmTimeReportSummaryResponseModalData: state => state.confirmTimeReportSummaryResponseModalData,
    }),

    DRAWER_STATE: {
      get() {
        return this.drawer
      },
      set(newValue) {
        if (newValue === this.drawer) return;
        this.TOGGLE_DRAWER();
      }
    },
  },
  methods: {
    ...mapActions('layoutCompany', [ 'TOGGLE_DRAWER', 'getSidebarHeaders']),
    ...mapActions("updateVisibleCreateInvoiceModal", ["updateVisibleCreateInvoiceModal"]),
    ...mapActions("getInvoiceNumber", ["getInvoiceNumber"]),
    ...mapActions("getRecipients", ["getRecipients"]),
    ...mapActions("getProjects", ["getProjects"]),
    ...mapActions("updateVisibleGuideModal", ["updateGuidesModalVisible"]),
    ...mapActions("saveInvoice", ["updateVisibleModal"]),
    ...mapActions("saveProjectReport", ["hideModalSendTimeReport"]),
    ...mapActions("getTimeReportClientPersons", ["getTimeReportClientPersons"]),
    ...mapActions("sendTimeReport", ["sendTimeReport", "prepareTimeReport"]),
    ...mapActions("updateVisibleTimeReportClientPersonsModal", ["updateVisibleTimeReportClientPersonsModal"]),
    ...mapActions("updateVisibleTimeReportSendEmailModal", ["updateVisibleTimeReportSendEmailModal"]),
    ...mapActions("updateVisibleTimeReportSummaryTableModal", ["updateVisibleTimeReportSummaryTableModal"]),
    ...mapActions("confirmTimeReportSummary", ["updateVisibleConfirmTimeReportSummaryResponseModal"]),

    hideTimeReportSummaryTableModal() {
      this.updateVisibleTimeReportSummaryTableModal({
        isModalVisible: false,
        timeReportItems: [],
        timeReportId: null
      })
    },

    hideConfirmTimeReportSummaryResponseModal() {
      this.updateVisibleConfirmTimeReportSummaryResponseModal(false);
    },

    showTimeReportPersons() {
      const url = new URL(window.location.href);
      let id = url.searchParams.get("timeReportId");
      if (!id) {
        id = this.timeReportData.id
        this.getTimeReportClientPersons({ creds: { id } });
        this.prepareTimeReport(this.timeReportData)
      } else {
        this.getTimeReportClientPersons({ creds: { id } });
        this.prepareTimeReport(this.dataReceive)
      }
      this.updateVisibleTimeReportClientPersonsModal(true);
      this.hideModalSendTimeReport(false);
    },

    showTimeReportEmailForm() {
      const url = new URL(window.location.href);
      let id = url.searchParams.get("timeReportId");
      if (!id) {
        this.prepareTimeReport(this.timeReportData)
      } else {
        this.prepareTimeReport(this.dataReceive);
      }
      this.updateVisibleTimeReportSendEmailModal(true);
      this.hideModalSendTimeReport(false);
    },

    hideInvoiceModal() {
      this.updateVisibleModal(false);
    },

    isRouteModule: function(child) {
      if(child.link.split('/')[2] !== undefined) {
        return child.link.split('/')[1] === this.$route.meta.module && child.link.split('/')[2] === this.$route.meta.subModule;
      } else {
        return child.link.split('/')[1] === this.$route.meta.module && this.$route.meta.subModule === "";
      }
    },
    hideModalCreateInvoice: function() {
      this.updateVisibleCreateInvoiceModal(false);
    },
    createInvoice: function() {
      this.updateVisibleCreateInvoiceModal(true);
    },
    downloadInvoicePdf: function(result) {
      downloadFileHelper(result);
    },
    downloadTimeReportPdf(result) {
      downloadFileHelper(result);
    },
    openGuidesModal(guideKey) {
      this.updateGuidesModalVisible({
        isGuidesModalVisible: true,
        guideKey
      });
    },
    hideGuidesModal() {
      this.updateGuidesModalVisible({
        isGuidesModalVisible: false,
        guideKey: null
      });
    }
  },
  beforeDestroy() {
    eventBus.$off('saveInvoiceSuccess');
    eventBus.$off('sendInvoiceSuccess');
  }
}
</script>

<style src="./Sidebar.scss" lang="scss"></style>